module.exports = __webpack_public_path__ + "img/step_3.52595fbe.svg";